import { BessStatus, ChargerOperationalStatus, ChargerStatus, SiteAlertState, SiteReadinessState } from '@core/api/sites/sites.enums';

import {
  BessStatusStoreModelEnum,
  ChargerOperationalStatusStoreModelEnum,
  ChargerStatusStoreModelEnum,
  SiteAlertStateStoreModelEnum,
  SiteReadinessStateStoreModelEnum,
} from './sites.enums';

export const mapSiteAlertStateApiModelEnumToStoreModelEnum = (siteAlertState: SiteAlertState): SiteAlertStateStoreModelEnum => {
  return {
    [SiteAlertState.Alerts]: SiteAlertStateStoreModelEnum.Alerts,
    [SiteAlertState.Issues]: SiteAlertStateStoreModelEnum.Issues,
    [SiteAlertState.NoIssues]: SiteAlertStateStoreModelEnum.NoIssues,
  }[siteAlertState];
};

export const mapBessStatusApiModelEnumToStoreModelEnum = (bessStatus: BessStatus): BessStatusStoreModelEnum => {
  return {
    [BessStatus.Faulty]: BessStatusStoreModelEnum.Faulty,
    [BessStatus.Performing]: BessStatusStoreModelEnum.Performing,
  }[bessStatus];
};

export const mapSiteReadinessStateApiModelEnumToStoreModelEnum = (
  siteReadinessState: SiteReadinessState
): SiteReadinessStateStoreModelEnum => {
  return {
    [SiteReadinessState.Ready]: SiteReadinessStateStoreModelEnum.Ready,
    [SiteReadinessState.UnderCommissioning]: SiteReadinessStateStoreModelEnum.UnderCommissioning,
  }[siteReadinessState];
};

export const mapChargerOperationalStatusApiModelEnumToStoreModelEnum = (
  chargerStatus: ChargerOperationalStatus
): ChargerOperationalStatusStoreModelEnum => {
  return {
    [ChargerOperationalStatus.Operational]: ChargerOperationalStatusStoreModelEnum.Operational,
    [ChargerOperationalStatus.Maintenance]: ChargerOperationalStatusStoreModelEnum.Maintenance,
    [ChargerOperationalStatus.Faulted]: ChargerOperationalStatusStoreModelEnum.Faulted,
    [ChargerOperationalStatus.Offline]: ChargerOperationalStatusStoreModelEnum.Offline,
  }[chargerStatus];
};

export const mapChargerStatusApiModelEnumToStoreModelEnum = (chargerStatus: ChargerStatus): ChargerStatusStoreModelEnum => {
  return {
    [ChargerStatus.ONLINE]: ChargerStatusStoreModelEnum.Online,
    [ChargerStatus.OFFLINE]: ChargerStatusStoreModelEnum.Offline,
  }[chargerStatus];
};
